export default __webpack_public_path__ + "static/media/bitcoin.01c10c80.png";